require("./ModuleCard.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function (input) {
        this.state = { editable: !input.title };
    },
    onAction: function (type) {
        switch (type) {
        case 'add':
            this.emit('toggle', this.input.index);
            break;
        case 'edit':
            this.state.editable = true;
            setTimeout(() => this.getEl('editable-title').focus(), 200);
            break;
        case 'save':
            this.saveChanges();
            break;
        case 'delete':
            this.emit('delete', this.input.index);
            break;
        }
    },
    saveChanges: function (type, e) {
        const title = this.getEl('editable-title').innerText;
        if (!title)
            return;
        this.emit('edit', this.input.index, {
            title,
            subtitle: this.getEl('editable-subtitle').innerText
        });
        setTimeout(() => this.state.editable = false, 200);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Courses/components/ModuleCard.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "d-flex align-items-center pl-3"
      },
    marko_attrs1 = {
        "class": "collapse-title w-75"
      },
    marko_attrs2 = {
        "class": "card-content theme-bg"
      },
    marko_attrs3 = {
        "class": "position-absolute d-block p-50 move-handle cursor-move",
        style: "left:5px",
        title: "Move"
      },
    marko_attrs4 = {
        "class": "theme-bg-fade border-top px-1 py-1 mt-1 justify-content-center text-right"
      },
    marko_attrs5 = {
        "class": "px-50 cursor-pointer d-inline-flex align-items-center"
      },
    marko_attrs6 = {
        "class": "px-50 cursor-pointer d-inline-flex align-items-center"
      },
    marko_attrs7 = {
        "class": "px-50 cursor-pointer d-inline-flex align-items-center"
      },
    marko_attrs8 = {
        "class": "px-50 cursor-pointer d-inline-flex align-items-center"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "card-module theme-bg mx-0 sortable-item",
        input.class
      ])),
      "data-index": input.index
    }, "0", component);

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "card-header collapse-header overflow-hidden py-2",
        input.headerClass
      ])),
      "data-toggle": !state.editable ? "collapse" : false,
      "data-target": "#" + input.target,
      style: "box-shadow:none!important"
    }, "1", component);

  out.be("div", marko_attrs0, "2", component);

  if (input.editable) {
    out.be("span", marko_attrs3, "3", component, null, 0, {
        onclick: __component.d("click", "onAction", false, [
            "move"
          ])
      });

    Bx_tag({
        type: "dots-vertical-rounded",
        class: "font-medium-5 p-0 text-muted",
        style: "width:5px"
      }, out, __component, "4");

    Bx_tag({
        type: "dots-vertical-rounded",
        class: "font-medium-5 p-0 text-muted",
        style: "width:5px;"
      }, out, __component, "5");

    out.ee();
  }

  out.be("div", marko_attrs1, "6", component);

  out.be("span", {
      "class": marko_classValue("d-block align-middle rounded ml-1 font-medium-3 " + (state.editable ? "border" : "")),
      contenteditable: state.editable,
      placeholder: Locale("Module Name")
    }, "@editable-title", component);

  Locale_tag({
      text: input.title || "New Module"
    }, out, __component, "7");

  out.ee();

  out.be("span", {
      "class": marko_classValue("d-block align-middle ml-1 rounded font-small-3 text-muted " + (state.editable ? "border" : "")),
      contenteditable: state.editable,
      placeholder: Locale("Add some description")
    }, "@editable-subtitle", component);

  if (input.subtitle) {
    Locale_tag({
        text: input.subtitle
      }, out, __component, "8");
  }

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.be("div", {
      id: input.target,
      "class": marko_classValue(marko_classValue([
        "collapse",
        input.contentClass
      ])),
      style: marko_styleValue(state.editable ? "display:block" : false)
    }, "9", component, null, 1);

  out.be("div", marko_attrs2, "10", component);

  out.be("div", {
      "class": "card-body nested-sortable-list px-0 py-50",
      style: "min-height: 0.5rem;",
      "data-parent-index": input.index
    }, "11", component);

  marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "12");

  out.ee();

  if (input.editable) {
    out.be("div", marko_attrs4, "13", component);

    if (state.editable) {
      out.be("span", marko_attrs5, "14", component, null, 0, {
          onclick: __component.d("click", "onAction", false, [
              "save"
            ])
        });

      Bx_tag({
          type: "save",
          class: "font-medium-4 text-primary"
        }, out, __component, "15");

      Locale_tag({
          text: "Save Changes",
          class: "px-50 text-primary"
        }, out, __component, "16");

      out.ee();
    } else {
      out.be("span", marko_attrs6, "17", component, null, 0, {
          onclick: __component.d("click", "onAction", false, [
              "add"
            ])
        });

      Bx_tag({
          type: "plus",
          class: "font-medium-4"
        }, out, __component, "18");

      Locale_tag({
          text: "Add Content",
          class: "px-50"
        }, out, __component, "19");

      out.ee();

      out.be("span", marko_attrs7, "20", component, null, 0, {
          onclick: __component.d("click", "onAction", false, [
              "edit"
            ])
        });

      Bx_tag({
          type: "pencil",
          class: "font-medium-4"
        }, out, __component, "21");

      Locale_tag({
          text: "Edit Module",
          class: "px-50"
        }, out, __component, "22");

      out.ee();

      out.be("span", marko_attrs8, "23", component, null, 0, {
          onclick: __component.d("click", "onAction", false, [
              "delete"
            ])
        });

      Bx_tag({
          type: "trash",
          class: "font-medium-4"
        }, out, __component, "24");

      Locale_tag({
          text: "Delete Module",
          class: "px-50"
        }, out, __component, "25");

      out.ee();
    }

    out.ee();
  }

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
